const style = theme => ({
  root: {
    width: '920px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    height: '100%',
    '@media (max-width: 1024px)': {
      width: 'calc(100vw - 100px)',
    },
    '@media (max-width: 768px)': {
      width: 'calc(100vw - 100px)',
    },
    '@media (max-width: 480px)': {
      width: 'calc(100vw - 100px)',
    },
  },
  headerContent: {
    height: 60,
    marginBottom: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    //marginTop: theme.spacing(2),
  },
  tabPanel: {
    height: '100%',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    boxSizing: 'border-box',
    paddingTop: 0,
    paddingBottom: 0,
    backgroundColor: 'white',
    width: '100%',
    height: '100%',
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    gap: theme.spacing(2),
  },
  mediaContainer: {
    maxHeight: '418px',
    overflow: 'auto',
    flex: 1,
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: theme.spacing(1),
  },
  imageList: {
    paddingTop: 0,
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    alignContent: 'flex-start',
    height: '100%',
    '& > *': {
      flex: '0 0 calc(25% - 8px)',
      maxWidth: 'calc(25% - 8px)',
      minWidth: '200px',
    },
    '@media (max-width: 768px)': {
      '& > *': {
        flex: '0 0 calc(50% - 1px)',
        maxWidth: 'calc(50% - 1px)',
      },
    },
    '@media (max-width: 480px)': {
      '& > *': {
        flex: '0 0 100%',
        maxWidth: '100%',
      },
    },
  },
  tabPanel: {
    width: '100%',
    height: '492px',
  },
  entityNull: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  dropAreaWide: {
    width: '100%',
    height: 'calc(100% - 6px)',
    border: '3px dashed gray',
    backgroundColor: '#eff2f7',
    zIndex: 1300,
    padding: 16,
    //pointerEvents: 'none',
  },
  button: {
    margin: theme.spacing(1),
  },
  leftIcon: {
    marginRight: theme.spacing(1),
  },
  rightIcon: {
    marginLeft: theme.spacing(1),
  },
  iconSmall: {
    fontSize: 20,
  },
  subTitle: {
    height: '40px !important',
    borderBottom: '1px solid #e2e2e2',
    marginBottom: 16,
    marginTop: 16,
    width: '100% !important',
  },

  linkPanel: {
    maxWidth: '530px',
    margin: '40px auto',
  },
  giphyPanel: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  giphyBadge: {
    position: 'absolute',
    bottom: 16,
    right: 8,
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    borderRadius: '4px',
    padding: '4px 10px',
    zIndex: 1,
  },
  giphyBadgeText: {
    color: '#8e9297',
    fontSize: '6px',
    fontWeight: 500,
    letterSpacing: '1px',
  },
  giphyBadgeLogo: {
    color: '#000',
    fontSize: '10px',
    fontWeight: 800,
    letterSpacing: '0.5px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  infoText: {
    marginTop: 32,
    marginBottom: 16,
    borderBottom: '1px solid #c5c6c7',
  },
  imageUploadInput: { display: 'none' },
  giphyListWrapper: {
    overflowY: 'auto',
    overflowX: 'hidden',
  },
})

export default style
